import { api } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useUserInfo() {
  const queryKey = ['userInfo'];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      return api.get('userinfo', { signal }).json();
    },
    staleTime: 1000 * 60 * 60,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
